export enum BankruptcyJobStatus {
    Running = 0,
    Completed = 1,
    Failed = 2
}

export enum BankruptcyOperationStatus {
    NotStarted = 0,
    Success = 1,
    Failed = 2,
    PartialSuccess = 3,
    Skipped = 4
}

export interface BankruptcyJobListItemDto {
    jobId: number;
    startedAt: string;
    completedAt: string | null;
    status: BankruptcyJobStatus;
    errorMessage: string | null;
    totalCustomers: number;
    successfulCustomers: number;
    failedCustomers: number;
    partiallySuccessfulCustomers: number;
    skippedCustomers: number;
    totalSubscriptionsTerminated: number;
    totalSubscriptionsFailed: number;
    duration: string | null;
    successRate: number;
}

export interface BankruptcyJobSummaryDto {
    totalCustomers: number;
    successfulCustomers: number;
    failedCustomers: number;
    partiallySuccessfulCustomers: number;
    skippedCustomers: number;
    totalSubscriptionsTerminated: number;
    totalSubscriptionsFailed: number;
    successRate: number;
}

export interface BankruptcySubscriptionResultDto {
    id: number;
    customerResultId: number;
    subscriptionId: string;
    tierName: string;
    status: BankruptcyOperationStatus;
    terminationDate: string | null;
    errorMessage: string | null;
    processedAt: string;
    attemptNumber: number;
}

export interface BankruptcyCustomerErrorDto {
    id: number;
    customerResultId: number;
    type: number;
    message: string;
    createdAt: string;
}

export interface BankruptcyCustomerResultDto {
    id: number;
    jobId: number;
    organizationNumber: string;
    vossCustomerId: string;
    customerNumber: string;
    customerName: string;
    customerLookupStatus: BankruptcyOperationStatus;
    customerUpdateStatus: BankruptcyOperationStatus;
    invoiceCheckStatus: BankruptcyOperationStatus;
    vbProductCheckStatus: BankruptcyOperationStatus;
    subscriptionFetchStatus: BankruptcyOperationStatus;
    emailSendStatus: BankruptcyOperationStatus;
    overallStatus: BankruptcyOperationStatus;
    processedAt: string;
    successfulSubscriptionCount: number;
    failedSubscriptionCount: number;
    totalSubscriptionCount: number;
    companyStatusCode: string | null;
    companyStatusName: string | null;
    companyStatusDate: string | null;
    hasUnpaidInvoices: boolean | null;
    hasVbProducts: boolean | null;
    manuallyHandled: boolean | null;
    subscriptionResults: BankruptcySubscriptionResultDto[];
    errors: BankruptcyCustomerErrorDto[];
}

export interface BankruptcyJobDetailDto {
    jobId: number;
    startedAt: string;
    completedAt: string | null;
    status: BankruptcyJobStatus;
    errorMessage: string | null;
    summary: BankruptcyJobSummaryDto;
    duration: string | null;
}

export interface BankruptcyTerminationState {
    jobs: BankruptcyJobListItemDto[] | null;
    jobsTotalPages: number;
    jobDetail: BankruptcyJobDetailDto | null;
    customerResults: BankruptcyCustomerResultDto[] | null;
    customerResultsTotalPages: number;
}
